import { DEFAULT_RANGE } from "@/app/config-global";
import { useLocales } from "@/app/locales";
import useFilters from "@/core/hooks/useFilters";
import useTranslation from "@/core/hooks/useTranslation";
import TablePage, {
  ICustomBreadcrumbsLink,
} from "@/presentation/components/TablePage";
import sliceNames from "@/redux/names";
import provisioningEffects from "@/redux/slices/provisioning/effects";
import provisioningColumns from "./data/columns";
import {
  provisioningTableTopOptions,
  provisioningToolbarOptions,
} from "./data/constants";
import provisioningFields from "./data/fields";

interface IProvisioningProps {
  additionalFilters?: Record<string, string | undefined>;
  breadcrumbs?: null | ICustomBreadcrumbsLink[];
  noPage?: boolean;
}
export default function ProvisioningsPage({
  additionalFilters,
  breadcrumbs,
  noPage,
}: IProvisioningProps) {
  // Hooks
  const t = useTranslation();
  const {
    currentLang: { value: lang },
  } = useLocales();
  const {
    getData,
    handleKeyword,
    handlePaymentType,
    handleStatus,
    handleOrder,
    handleOrder_field,
    handlePage,
    handlePer_page,
    keyword,
    paymentType,
    status,
    order: _order,
    order_field,
  } = useFilters({
    effects: provisioningEffects,
    initialState: {
      page: 1,
      per_page: DEFAULT_RANGE.per_page,
      keyword: "",
      paymentType: "",
      status: "",
      order: "",
      order_field: "",
      ...(additionalFilters ?? {}),
    },
  });

  return (
    <TablePage
      model={sliceNames.provisioning}
      // ** Breadcrumbs **
      breadcrumbLinks={breadcrumbs}
      // ** Genre **
      // female
      // ** Toolbar **
      tableTopOptions={provisioningTableTopOptions}
      toolbarOptionChange={handleStatus}
      currentToolbarOption={status}
      toolbarOptions={provisioningToolbarOptions({
        value: keyword,
        onChange: handleKeyword,
      })}
      // ** On Select rows **
      idProperty="uuid"
      // ** Table CRUD **
      noUpdate
      noDelete
      noDeleteBulk
      noCheckBoxes
      fields={provisioningFields(t, lang)}
      columns={provisioningColumns}
      effects={provisioningEffects}
      getData={getData}
      // ** Filter options **
      isFiltered={() => keyword !== "" || paymentType !== "" || status !== ""}
      onReset={() => {
        handleKeyword("");
        handlePaymentType("");
        handleStatus("");
      }}
      // ** Sorting **
      handleFilterOrder={handleOrder}
      handleFilterOrderField={handleOrder_field}
      order={_order}
      orderField={order_field}
      // ** Pagination **
      onChangePage={handlePage}
      onChangeRowsPerPage={handlePer_page}
      noPage={noPage}
    />
  );
}
